import React from 'react';
import { Spin } from 'antd';
import { Modal } from '@mui/material';
import styled from 'styled-components';

const VideoContainer = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

interface SpinLoaderProps {
  dataloader: boolean; // Type definition for the `dataloader` prop
}

const SpinLoader: React.FC<SpinLoaderProps> = ({ dataloader }) => {
  return (
    <Modal open={dataloader} style={{ zIndex:999999999999999}} className='assignment-image-modal'>
      <VideoContainer>
        <Spin size="large" />
      </VideoContainer>
    </Modal>
  );
};

export default SpinLoader;